import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTableData } from '../useTableData';
import { legalsService, type LegalItem, type LegalTableItem } from '../../services/legalsService';

export function useTableDataLegals() {
    const navigate = useNavigate();

    const fetchForTable = useCallback(async (params: { page: number; page_size: number; search?: string }) => {
        const response = await legalsService.getLegalsList(params);
        return {
            count: response.count,
            results: response.results.map((item: LegalItem): LegalTableItem => ({
                id: item.id,
                checked: false,
                disabled: false,
                data: {
                    name: item.name,
                    legal_text: item.legal_text,
                    color: item.color,
                    is_active: item.is_active,
                },
            })),
        };
    }, []);

    const deleteItems = useCallback(async (ids: string[]) => {
        const results = await Promise.all(ids.map(id => legalsService.deleteLegal(id)));
        const failed = results.find(r => !r.success);
        return {
            success: !failed,
            message: failed?.message || 'Legales eliminados exitosamente',
        };
    }, []);

    const tableData = useTableData<LegalTableItem>({
        fetchData: fetchForTable,
        deleteItems,
        getDeleteLabel: (item) => item.data.name,
        itemType: 'Legales',
    });

    const handleCreateLegal = () => navigate('/legals');
    const handleEdit = (id: string | number) => navigate(`/legals/${id}`);

    return {
        ...tableData,
        handleCreateLegal,
        handleEdit,
    };
}
